export default function ResultsListItemMeta({ data }) {
    return (
        <div className="results-list-item__meta">
            { data.map((text, index) => <p key={index}>{ text === 'pending' ? 'Ready to Score' : text }</p>) }
        </div>
    )
}

